import { api } from 'store/api/configService';

import { appendTopGamesPercentage } from 'utils/analytics';

const analyticsController = api.injectEndpoints({
  endpoints: (build) => ({
    getTrendingByGeo: build.query({
      query: () => ({
        url: '/config-service/client-area/v1/analytics/trending-by-geo',
      }),
    }),
    getRegions: build.query({
      query: () => ({
        url: '/config-service/client-area/v1/analytics/regions',
      }),
    }),
    getMetrics: build.query({
      query: () => ({
        url: '/config-service/client-area/v1/analytics/enums/metrics',
      }),
    }),
    getTopGames: build.query({
      query: ({ category, period, region, country, sortBy, limit, order }) => ({
        url: '/config-service/client-area/v1/analytics/top-games',
        params: {
          category,
          'period.fromMonth': period.fromMonth,
          'period.toMonth': period.toMonth,
          region,
          country,
          sortBy,
          limit,
          order,
        },
      }),
      transformResponse: appendTopGamesPercentage,
    }),
    getRetentionPeriods: build.query({
      query: () => ({
        url: '/config-service/client-area/v1/analytics/enums/retention-periods',
      }),
    }),
    getTopGamesByRetention: build.query({
      query: ({ category, period, region, country, limit }) => ({
        url: '/config-service/client-area/v1/analytics/top-games-by-retention',
        params: {
          category,
          period,
          region,
          country,
          limit,
        },
      }),
      transformResponse: appendTopGamesPercentage,
    }),
  }),
});

export const {
  useGetTrendingByGeoQuery,
  useGetRegionsQuery,
  useGetMetricsQuery,
  useGetTopGamesQuery,
  useGetRetentionPeriodsQuery,
  useGetTopGamesByRetentionQuery,
} = analyticsController;
